import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { IAuctionDefaultData } from '../../articles-manager/interfaces/auction-default-data.interface';
import {
  Auction,
  AuctionDto,
  AuctionPrice,
  AuctionToPayView,
  AuctionType,
  AuctionView,
} from '../../articles-manager/interfaces/auction.interface';
import { ApiServiceHolder } from '../utils/api-service-holder';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AuctionService {
  private _defaultData: IAuctionDefaultData = { articlePropertiesDefault: [] };

  get defaultData(): IAuctionDefaultData {
    return this._defaultData;
  }

  constructor(private _api: ApiService) {}

  save(item: Auction): Observable<Auction> {
    return this._api.request(ApiServiceHolder.auction.save(item));
  }

  getByPk(idAuction: number): Observable<Auction> {
    return this._api.request(ApiServiceHolder.auction.getByPkV2(idAuction));
  }

  getAllTypes(): Observable<AuctionType[]> {
    return this._api.request(ApiServiceHolder.auction.getAllTypes());
  }

  delete(idAuction: number): Observable<any> {
    return this._api.request(ApiServiceHolder.auction.delete(idAuction));
  }

  edit(idAuction: number, data: AuctionDto) {
    return this._api.request(ApiServiceHolder.auction.edit(idAuction, data));
  }

  getAllToPay(idLanguage: number): Observable<AuctionToPayView[]> {
    return this._api.request(ApiServiceHolder.auction.getAllToPay(idLanguage));
  }

  getAll(idLanguage: number): Observable<AuctionView[]> {
    return this._api.request<AuctionView[]>(
      ApiServiceHolder.auction.getAll(idLanguage)
    );
  }

  getAllSeller(idLanguage: number): Observable<AuctionView[]> {
    return this._api.request<AuctionView[]>(
      ApiServiceHolder.auction.getAllSeller(idLanguage)
    );
  }

  getAllByEntity(
    idLanguage: number,
    idEntity: number,
    onlyApproved: number
  ): Observable<AuctionView[]> {
    return this._api.request<AuctionView[]>(
      ApiServiceHolder.auction.getAllByEntity(
        idLanguage,
        idEntity,
        onlyApproved
      )
    );
  }

  getDefaultData(): Observable<IAuctionDefaultData> {
    return this._api
      .requestLocalStorageCached<IAuctionDefaultData>(
        ApiServiceHolder.auction.getDefaultData()
      )
      .pipe(tap((data) => (this._defaultData = data)));
  }

  getCurrentPrices(idAuctionList: number[]): Observable<AuctionPrice[]> {
    return this._api.request(
      ApiServiceHolder.auction.getCurrentPrices(idAuctionList)
    );
  }
}
